import { useI18n } from "../../i18n/LanguageProvider";
import { motion } from "framer-motion";
import { Container, SectionLabel } from "../Container";
import { Reveal } from "../Reveal";
import { Lock, ServerCog, EyeOff, ShieldCheck, CreditCard } from "lucide-react";
import { withStripe } from "../StripeMark";

const icons = [CreditCard, ServerCog, EyeOff, ShieldCheck, Lock];

export function Security() {
  const { t } = useI18n();
  const points = t("security.points");

  return (
    <section className="relative overflow-hidden py-32 md:py-40">
      <div className="pointer-events-none absolute right-0 top-0 h-[520px] w-[520px] translate-x-1/4" style={{ background: "radial-gradient(circle, rgba(77,215,154,0.22) 0%, transparent 65%)" }} />
      {/* 3D shield creative */}
      <motion.img
        src="/3d/shield.png"
        alt=""
        aria-hidden="true"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1, y: [0, -14, 0] }}
        transition={{ opacity: { duration: 0.9 }, scale: { duration: 0.9 }, y: { duration: 6, repeat: Infinity, ease: "easeInOut" } }}
        className="pointer-events-none absolute -right-6 top-24 z-0 hidden h-72 w-72 select-none drop-shadow-2xl lg:block xl:right-10 xl:h-80 xl:w-80"
      />
      <Container className="relative z-10">
        <div className="max-w-3xl">
          <SectionLabel>{t("security.label")}</SectionLabel>
          <Reveal>
            <h2 className="text-3xl font-semibold leading-tight tracking-tight text-black sm:text-4xl lg:text-5xl">
              {withStripe(t("security.title"))}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg leading-relaxed text-black/55">{t("security.subtitle")}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-x-16 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
          {points.map((p, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={p.title} delay={(i % 3) * 0.06}>
                <div className="flex gap-4">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-green/10 text-green">
                    <Icon strokeWidth={1.5} className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold tracking-tight text-black">{withStripe(p.title)}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-black/55">{withStripe(p.text)}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
